export const ACTIONS = {
  SET_COMPANY: 'setCompany',
  SET_IS_NEW_COMPANY: 'setIsNewCompany',
  OPEN_COMPANY_SELECT_BOX: 'openCompanySelectBox',
  SET_COMPANY_SEARCH_INPUT: 'setCompanySearchInput',
  SET_SHOW_COMPANY_CREATE_ERROR: 'setShowCompanyCreateError',
  SET_ROLE: 'setRole',
  SET_ROLE_SEARCH_INPUT: 'setRoleSearchInput',
  SET_ACCESS_LEVEL: 'setAccessLevel',
  SHOW_MAIN_MODAL: 'showMainModal',
  SHOW_CONFIRMATION_MODAL: 'showConfirmationModal',
  RESET_INFORMATION: 'resetInformation',
  SET_EMAIL_SEARCH_INPUT: 'setEmailSearchInput',
  SET_EMAILS: 'setEmails',
  SET_IS_SAVING: 'setIsSaving',
  SET_ARE_USERS_INVITED: 'setAreUsersInvited',
};
